"use client";

import useSWR from "swr";
import { MD5 } from "crypto-js";
import useUserStore from "@/stores/useUserStore";
import { FETCH_AUCTION_FAVORITE_TIME } from "@/lib/auctions";
import useUserFavoritesStore from "@/stores/useUserFavoritesStore";

export const useFetchUserFavorites = (userId?: number) => {
    const { fetchKeys } = useUserStore();
    const { setUserFavorites } = useUserFavoritesStore();

    const favoriteFetchKey = fetchKeys?.favorites || MD5(`userFavorites-${userId}`).toString();

    useSWR<any, Error>(
        userId ? favoriteFetchKey : null,
        async () => {
            const res = await fetch(`/api/user/favorites?cacheKey=${encodeURIComponent(favoriteFetchKey)}`);
            const data = await res.json();
            const favorites = data?.favorites || [];

            setUserFavorites(favorites);

            return favorites;
        },
        {
            refreshInterval: FETCH_AUCTION_FAVORITE_TIME
        }
    );

};
